module.exports = __webpack_public_path__ + "static/img/kookminbank-archive.d4d930e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/kookminbank-archive.jpg
// module id = 2EZi
// module chunks = 0